module.exports = __webpack_public_path__ + "static/media/RoundedRect_Primary@2x.865e6424.png";